/**
 * Copyright (c) 2020-2024, hitobito AG. This file is part of
 * hitobito and licensed under the Affero General Public License version 3
 * or later. See the COPYING file at the top-level directory or at
 * https://github.com/hitobito/hitobito.
 */


  // Import all JavaScript files of the wagons (they can provide a
  // app/assets/javascripts/wagon.js.coffee file to be included in the
  // bundle).
  
  

  // Import all image files of the wagons, so they can be referenced
  // with the `wagon_image_pack_tag` and `wagon_favicon_pack_tag` helpers.
  
  

  // Import all JavaScript files of the wagons (they can provide a
  // app/assets/javascripts/wagon.js.coffee file to be included in the
  // bundle).
  
  
    import '/app-src/vendor/wagons/hitobito_sac_cas/app/assets/javascripts/wagon.js.coffee';
  

  // Import all image files of the wagons, so they can be referenced
  // with the `wagon_image_pack_tag` and `wagon_favicon_pack_tag` helpers.
  
  
    require.context('/app-src/vendor/wagons/hitobito_sac_cas/app/assets/images', true);
  

